<template>
  <NextReviewerModal
    ref="modal"
    :title="$t('directory.modal.selectNextReviewer')"
    :asyncSelectOptions="() => getOptions()"
    :required="true"
    v-bind="$attrs"
    @onOkClick="save"
  >
    <template slot="title">
      {{ $t('directory.modal.reAssign') }}
    </template>
    <template
      v-if="histories.length"
      slot="add-text"
    >
      <HKLGrayHint>
        <div>{{ $t('directory.modal.assignedHistory') }}</div>
        <ol>
          <li
            v-for="(item, index) in histories"
            :key="index"
          >
            {{ $t('action.assignedBy', [item.displayName, item.createdAt]) }}
          </li>
        </ol>
      </HKLGrayHint>
    </template>
  </NextReviewerModal>
</template>

<script>
import lodash from 'lodash'
import { unref, computed } from 'vue-demi'
import NextReviewerModal from '@/controls/Modal/NextReviewerModal'
import HKLGrayHint from '@/controls/HKLGrayHint'
import { useRefModal } from '@/controls/Modal/modal.hook'
import { useRouteParamId } from '@/router/useRouter'
import { useStoreGetters, useStoreActions } from '@/store/index'
import { PermTypeMapKeys } from '@/utils/aclHelper'
import { getUsersForSameBuilding } from '@/modules/tenantProjects/utils'
import * as directoryRequest from '@/api/directories/request'
import dateUtil, { DD_MMM_YY_HH_MM } from '@/utils/dateUtil'
import { useUnderReviewerHistories } from './hook'

const getHistories = async (tenancyId) => {
  let { data: { data: histories } } = await directoryRequest.getReviewerHistories({ tenancyId })
  histories = lodash.orderBy(histories, ['createdAt'], ['desc'])
  return histories
}

export default {
  components: {
    NextReviewerModal,
    HKLGrayHint,
  },
  setup () {
    let returnData = {}
    const { open, modal } = useRefModal()
    returnData = {
      ...returnData,
      open,
      modal,
    }
    const { currentTenancyRef } = useStoreGetters('ccd', ['currentTenancy'])
    const { loadTenancy } = useStoreActions('ccd', ['loadTenancy'])
    const tenancyIdRef = useRouteParamId()
    const { data: historiesRef, refresh } = useUnderReviewerHistories(tenancyIdRef)
    const getOptions = async () => {
      const tenancyId = unref(tenancyIdRef)
      if (!unref(currentTenancyRef).id) {
        await loadTenancy(tenancyId)
      }
      const histories = await getHistories(tenancyId)
      historiesRef.value = histories

      const users = await getUsersForSameBuilding(
        unref(currentTenancyRef),
        PermTypeMapKeys.APPROVE_DIRECTORY,
        histories.length ? { id: histories[0].detail.value.id } : undefined,
        { includeTrReps: true },
      )
      return users.map((user) => {
        return {
          name: user.displayPicName,
          value: {
            id: user.id,
            username: user.username,
            displayName: user.displayName,
            email: user.email,
          },
        }
      })
    }
    returnData = {
      ...returnData,
      getOptions,
      histories: computed(() => {
        const histories = unref(historiesRef)
        return histories.map((history) => ({
          displayName: history.who.displayName,
          createdAt: dateUtil.format(history.createdAt, DD_MMM_YY_HH_MM),
        }))
      }),
      save: async () => {
        await directoryRequest.setReviewer({
          type: 'reviewer',
          value: JSON.parse(unref(modal).getSelectedValue()),
        }, { params: { tenancyId: unref(tenancyIdRef) } })
        refresh()
      },
    }
    return returnData
  },
}
</script>

<style lang="scss" scoped>
.tip {
  margin-top: 10px;
  dt {
    margin-bottom: 0;
  }
}
li.tip__text {
  list-style: decimal;
}
</style>
